import { axiosV2 } from "config/@axios";
import * as uiActions from "store/actions/uiActions";
import * as quarantineActions from "pages/Quarantine/store/quarantineActions";
import moment from "dayjs";

export const FETCH_QUARANTINES = "quarantinesActions::fetchQuarantines";
export const FETCH_QUARANTINES_SUCCESS =
  "quarantinesActions::fetchQuarantinesSuccess";
export const FETCH_QUARANTINES_FAILED =
  "quarantinesActions::fetchQuarantinesFailed";
export const FETCH_QUARANTINES_APPEND =
  "quarantinesActions::fetchQuarantinesAppend";
export const FETCH_QUARANTINES_APPEND_SUCCESS =
  "quarantinesActions::fetchQuarantinesAppendSuccess";
export const FETCH_QUARANTINES_APPEND_FAILED =
  "quarantinesActions::fetchQuarantinesAppendFailed";
export const DELETE_ITEMS = "quarantinesActions::deleteItems";

export const fetchByPage =
  ({ page, starttime, endtime, type, dlist, mailfrom, subject, header_from }) =>
  (dispatch, getState) => {
    const state = getState();
    const perPage = state.auth.settings.display_mail_count;
    let start;
    if (page < 1) {
      start = 0;
    } else {
      start = (page - 1) * perPage;
    }

    dispatch(quarantineActions.setPage(page));
    const params = {
      starttime: starttime ?? moment().startOf("day").unix(),
      endtime: endtime ?? moment().unix(),
      type: type ?? "quarantine",
      mailfrom,
      subject,
      header_from,
      count: perPage,
      start
    };

    if (dlist) {
      params.dlist = dlist;
    }

    return dispatch(fetchQuarantines(params));
  };

export const fetchNextPage =
  ({ page }) =>
  (dispatch, getState) => {
    const state = getState();
    const perPage = state.auth.settings.display_mail_count;
    const start = (page - 1) * perPage;

    dispatch(quarantineActions.setPage(page));
    return dispatch(
      fetchQuarantines({ count: perPage, start }, { append: true })
    );
  };

export const fetchQuarantines =
  (params = null, { append = false } = {}) =>
  (dispatch, getState) => {
    const state = getState();
    const searchParams = state.quarantine.searchParams;
    const displayMailCount = state.auth?.settings?.display_mail_count ?? 50;

    const currentParams = {
      ...searchParams,
      ...params
    };

    if (!currentParams.starttime) {
      currentParams["starttime"] = parseInt(
        new Date().setHours(0, 0, 0) / 1000
      );
    }
    if (!currentParams.endtime) {
      currentParams["endtime"] = parseInt(
        new Date().setHours(23, 59, 59) / 1000
      );
    }
    if (!currentParams.start) {
      currentParams["start"] = 0;
    }
    if (!currentParams.count) {
      currentParams["count"] = displayMailCount;
    }
    Object.keys(currentParams).forEach(el => {
      if (currentParams[el] === "") {
        delete currentParams[el];
      }
    });

    const fetchType = append ? FETCH_QUARANTINES_APPEND : FETCH_QUARANTINES;
    const successType = append
      ? FETCH_QUARANTINES_APPEND_SUCCESS
      : FETCH_QUARANTINES_SUCCESS;
    const failedType = append
      ? FETCH_QUARANTINES_APPEND_FAILED
      : FETCH_QUARANTINES_FAILED;

    dispatch({
      type: fetchType
    });

    return axiosV2
      .get("quarantines", { params: currentParams })
      .then(response => {
        const totalCount = response.headers["x-total-count"];
        let data = response.data;
        data = data.map(item => {
          return {
            ...item,
            deleted: false
          };
        });

        dispatch({
          type: successType,
          payload: {
            quarantines: data,
            totalCount,
            perPage: currentParams.count
          }
        });
        dispatch(quarantineActions.setSearchParams(currentParams));
        if (!append) {
          dispatch(uiActions.selectAll(false, "quarantines"));
        }
      })
      .catch(err => {
        dispatch({
          type: failedType,
          payload: {
            errorText: err.errorMessage
          }
        });
      });
  };

export const deleteItems = data => ({
  type: DELETE_ITEMS,
  payload: {
    data
  }
});
